import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

function FiltersFooter({ filters, fullWidth = false }) {
  // using inline styles to pdf styling is consistent
  return (
    <div style={{ "@media print": { display: "block" } }}>
      {
        filters.summary.length
          ? (
            <p style={{
              color: "grey",
              fontSize: 13,
              marginBottom: 0,
              position: "absolute",
              left: 35,
              bottom: 55,
              maxWidth: fullWidth ? "100%" : "75%",
              maxHeight: '40px',
              overflow:'hidden'
            }}>
              {`Filters Applied: ${filters.summary}`}
            </p>
          ) : null
      }
    </div>
  );
}

FiltersFooter.propTypes = {
  filters: PropTypes.object,
  fullWidth: PropTypes.bool,
};

export default connect((store) => {
  return {
    filters: store.filters,
  };
})(FiltersFooter);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/FiltersFooter.jsx